import {
	ROUTE_PROMOTION_BULK_ACTIONS,
	ROUTE_PROMOTION_BULK_ACTIONS_UPLOAD_READ,
	ROUTE_PROMOTION_BULK_ACTIONS_LOG,
	ROUTE_PROMOTION_BULK_ACTIONS_LOG_DETAIL
} from 'constants/RouterNames'

const viewData = () =>
	import('src/components/pages/secured/promotion/promotionBulkAction/promotionBulkActionBase.vue')
const page = () =>
	import('src/components/pages/secured/promotion/promotionBulkAction/promotionBulkAction.vue')
const logs = () =>
	import('src/components/pages/secured/promotion/promotionBulkAction/promotionBulkActionLogs/promotionBulkActionLogs.vue')
const logsDetail = () =>
	import('src/components/pages/secured/promotion/promotionBulkAction/promotionBulkActionLogs/bulkActionsLogsDetails/bulkActionsLogsDetails.vue')

const promotionBulkActionRoute = {
	path: '/promocao-em-massa/base',
	redirect: '/promocao-em-massa',
	component: viewData,
	name: ROUTE_PROMOTION_BULK_ACTIONS.name,
	meta: {
		breadcrumb: { name: 'Promoções ações em massa' },
		requiresAuthorities: ROUTE_PROMOTION_BULK_ACTIONS.routerAuth
	},
	children: [
		{
			path: '/promocao-em-massa',
			component: page,
			name: ROUTE_PROMOTION_BULK_ACTIONS_UPLOAD_READ.name,
			meta: { breadcrumb: { name: 'Promoções ações em massa', active: false } }
		},
		{
			path: '/promocao-em-massa/logs',
			component: logs,
			name: ROUTE_PROMOTION_BULK_ACTIONS_LOG.name,
			meta: {
				requiresAuthorities:
				ROUTE_PROMOTION_BULK_ACTIONS_LOG.routerAuth,
				breadcrumb: { name: 'Logs' }
			}
		},
		{
			path: '/acao-em-massa/log/detalhe/:id',
			props: true,
			component: logsDetail,
			name: ROUTE_PROMOTION_BULK_ACTIONS_LOG_DETAIL.name,
			meta: {
				breadcrumb: { name: 'Logs' },
				requiresAuthorities:
				ROUTE_PROMOTION_BULK_ACTIONS_LOG_DETAIL.routerAuth
			}
		}
	]
}

export default promotionBulkActionRoute
